export enum AppRoutings {
	Root = "/",
	Dashboard = "/contract-management-dashboard",
	InternalUsers = "/internal-users",
	InternalUserDetail = "/internal-user-detail",
	RequisitionSummaryGrid = "/requisition-summary-grid",
	SignIn = "/sign-in",
	RequisitionEntry = "/requisition-entry",
	Callback = "/callback",
	SignUp = "/sign-up",
	AccessDenied = "/access-denied",
	NotFound = "*",
	WorkflowSummaryGrid = "/workflow-summary-grid",
	WorkflowDefinition = "/workflow-definition",
	WorkflowStepDefinition = "/workflow-step-definition",
	DepartmentSummaryGrid = "/department-summary-grid",
	DepartmentDetail = "/department-detail",
	ItemSummaryGrid = "/item-summary-grid",
	ItemDetail = "/item-detail",
	ProgrammeSummaryGrid = "/programme-summary-grid",
	ProgrammeDetail = "/programme-detail",
	RequisitionConfirmation = "/requisition/:confirmationType/:requisitionId/:requisitionStepHistoryId",
	RequisitionEntryAction = "/requisition-entry/:actionType/:requisitionId/:requisitionStepHistoryId",
	RequisitionConversionToBid = "/requisition-conversion-to-bid",
	RequisitionConversionToBidAction = "/requisition-conversion-to-bid/convert/:requisitionId",
	BidSummaryGrid = "/bid-summary-grid",
	BidDetail = "/bid-detail",
	EvaluationMethodSummaryGrid = "/evaluation-method-summary-grid",
	SystemTemplateDefinition = "/system-template-definition",
	SystemTemplateSummaryGrid = "/system-template-summary-grid",
	TemplateTypeSummaryGrid = "/template-type-summary-grid",
	ProcurementMethodSummaryGrid = "/procurement-method-summary-grid",
	ProcurementMethodDetail = "/procurement-method-detail",
	RoleMenuAccessRights = "/role-menu-access-right",
	SDBDocumentGrid = "/sbd-document-grid",
	ContractSummaryGrid = "/contract-summary-grid",
	PORequestSummaryGrid = "/po-request-summary-grid",
	NewContractEntry = "/contract-entry",
	NewContractEntryAction = "/contract-entry/:actionType/:contractId/:contractStepId",
	BidConversionToPO = "/bid-conversion-to-po",
	BidConversionToContract = "/bid-conversion-to-contract",
	BidCommitteeSummaryGrid = "/bid-committee-summary-grid",
	BidCommitteeDetail = "/bid-committee-detail",
	SystemScheduler = "/system-scheduler",
	SchedulerEventConfirmation = "/system-scheduler/:confirmationType/:bidMeetingEventId",
	SchedulerEventModuleConfirmation = "/system-scheduler/:confirmationType/:module/:bidMeetingEventId",
	BidSpecificationMeeting = "/bid-specification-meeting",
	BidEvaluationMeeting = "/bid-evaluation-meeting",
	BidApproval = "/bid-approval",
	BidPublishing = "/bid-publishing",
	Bidding = "/bidding",
	CSDSegmentSummaryGrid = "/csd-segment-summary-grid",
	CSDFamilySummaryGrid = "/csd-family-summary-grid",
	CSDClassSummaryGrid = "/csd-class-summary-grid",
	CSDCommoditySummaryGrid = "/csd-commodity-summary-grid",
	SystemSetup = "/system-setup",
	BudgetAllocationSummaryGrid = "/budget-summary-grid",
	BudgetAllocationDetail = "/budget-allocation-detail",
	ErpDbCompanySummaryGrid = "/erp-db-company-summary-grid",
	ErpDbCompanyDetail = "/erp-db-company-detail",
	GlAccountSummaryGrid = "/gl-account-summary-grid",
	GlAccountDetail = "/gl-account-detail",
	BudgetChangeOrderSummaryGrid = "/budget-change-order-summary-grid",
	BudgetChangeOrderDetail = "/budget-change-order-detail",
	UserProfile = "/user-profile",
	BudgetAllocationConfirmation = "/budget-allocation/:confirmationType/:budgetAllocationId/:budgetAllocationStepId/:budgetAllocationStepDepartmentId",
	BudgetAllocationDetailAction = "/budget-allocation-detail/:actionType/:budgetAllocationId/:budgetAllocationStepId/:budgetAllocationStepDepartmentId",
	AdSync = "/ad-sync",
	ProcureToPayDashboard = "/procure-to-pay-dashboard",
	BudgetingProcessDashboard = "/budgeting-process-dashboard",
	FinancialPerformanceDashboard = "/financial-performance-dashboard",
	FixedAssetsTrackingDashboard = "/fixed-assets-tracking-dashboard",
	SupplyChainManagementPortal = "/supply-chain-management-portal",
	CompanyProfile = "/company-profile",
	ExternalUsers = "/external-users",
	ExpenditureSummaryGrid = "/expenditure-summary-grid",
	ExpenditureDetail = "/expenditure-detail",
	ContractManagementDashboard = "/contract-management-dashboard",
	PerformanceEvaluationSummaryGrid = "/evaluation-summary-grid",
	PerformanceEvaluationDetail = "/performance-evaluation-detail",
	PerformanceEvaluationHistoryDetail = "/performance-evaluation-history-detail",
	InvoiceUploadSummaryGrid = "/invoice-upload-summary-grid",
	SupplierDocumentUpload = "/supplier-document-upload",
	ExternalUserConfirmation = "/external-user/:confirmationType/:userId",
	ValidityPeriodSummaryGrid = "/validity-period-summary-grid",
	RegionSummaryGrid = "/region-summary-grid",
	SupplierBidSummary = "/supplier-bid-summary-grid",
	SupplierBidDetail = "/supplier-bid-detail",
	BidEntryAction = "/bid-entry/:actionType/:bidId/:bidStepId",
	BudgetChangeOrderEntryAction = "/budget-change-order-detail/:requisitionId/:budgetChangeOrderNumber",
	AuditTrails = "/user-activity-summary-grid",
	UserAccessAudit = "/user-access-audit",
	DetailUserActivity = "/detail-user-activity",
	TransactionAudit = "/transaction-audit",
	VariationSummaryGrid = "/variation-summary-grid",
	BidEvaluation = "/bid-evaluation",
	BidEvaluationDetail = "/bid-evaluation-detail",
	DivisionSummaryGrid = "/division-summary-grid",
	ContractConfirmation = "/contract/:confirmationType/:contractId/:contractStepId",
	ContractPOEntry = "/contract-po-entry",
	ContractPOConfirmation = "/contract-po/:confirmationType/:requisitionId/:requisitionStepHistoryId",
	ContractPOEntryAction = "/contract-po-entry/:actionType/:requisitionId/:requisitionStepHistoryId",
	ContractVariationEntry = "/contract-variation-entry",
	ContractVariationConfirmation = "/contract-variation/:confirmationType/:requisitionId/:requisitionStepHistoryId",
	ContractVariationEntryAction = "/contract-variation-entry/:actionType/:requisitionId/:requisitionStepHistoryId",
	EvaluationCategorySummaryGrid = "/evaluation-category-summary-grid",
	PurchaseOrderSummaryGrid = "/purchase-order-summary-grid",
	EvaluationElementSummaryGrid = "/evaluation-element-summary-grid",
	FinanceStatementDashboard = "/finance-statement-dashboard",
	CSDSupplierMaintenance = "/csd-supplier-maintenance",
	CSDDailyUpdates = "/csd-daily-updates",
	CSDRFQs = "/csd-rfq",
	CSDDailyUpdateDetailedGrid = "/csd-daily-detailed-update",
	BidCommitteeConfirmation = "/bid-committee-member/accept-appointment/:bidCommitteeMemberId",
	BidCommitteeDeclineConfirmation = "/bid-committee-member/decline-appointment/:bidCommitteeMemberId",
	BidCommitteeView = "/bid-committee/view/:bidCommitteeId",
	ContractCoordinators = "/coordinators-summary-grid",
	ConsolidatedProcurementPlanning = "/consolidated-procurement-plan-sg",
	AppDetail = "/app-detail",
	DepartmentalProcurementPlanning = "/departmental-procurement-plan-sg",
	DepartmentalProcurementPlanEntry = "/departmental-procurement-plan-entry",
	ContractTermination = "/contract/termination-scheduled/:contractId",
	ContractArchived = "/contract/archive-scheduled/:contractId",
	QuerySummary = "/query-summary-grid",
	ItemConfirmation = "/limited-item/:confirmationType/:itemId/:limitedItemStepId",
	PriceAndBeeSetting = "/price-and-bee-settings-summary-grid",
	PriceAndBeeSettingEntry = "/price-and-bee-evaluation-definition",
	BidConfirmation = "/bid/:confirmationType/:bidId/:bidStepId",
	BidQueryConfirmation = "/query/:confirmationType/:vendorBidQueryId",
	VendorBidQuery = "/vendor-bid-query",
	BidQuerySummaryGrid = "/bid-query-summary-grid",
	BidQueries = "/bid-queries",
	PerformanceEvaluationSettingSummaryGrid = "/performance-evaluation-summary-grid",
	PerformanceEvaluationSettingDetail = "/performance-evaluation-definition-detail",
	SupplierBillingPeriodDetail = "/supplier-billing-period-detail",
	ContractManagementSettings = "/contract-management-settings",
}
